module.exports = __webpack_public_path__ + "static/PillEfervescence-1d7dc8470ccf90e1b33376f6dae212b2.jpg";